<template>
	<div class="client-container">
		<div :style="{ overflow: 'hidden' }">
			<bread-crumb :style="{ float: 'left' }" />
			<a-select v-model="status" placeholder="全部" style="width: 142px;float:right;margin-top:19px;"
				@change="(value) => onChange(value)" :allowClear="true">
				<a-select-option value="0">全部</a-select-option>
				<a-select-option value="2">发布</a-select-option>
				<a-select-option value="1">待审核</a-select-option>
				<a-select-option value="3">隐藏</a-select-option>
			</a-select>
		</div>
		<div class="global-table-container">
			<a-table :columns="columns" :data-source="data" :loading="loading" :row-key="record => record.id"
				:pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }" @change="changePage">
		<template slot="content" slot-scope="text, record">
		  <a-tooltip
		    placement="bottomLeft"
		    :title="record.content"
		    color="#13c2c2"
		  >
		    <span class="ellipsis">{{ record.content }}</span>
		  </a-tooltip>
		</template>
		<template slot="reply_content" slot-scope="text, record">
		  <a-tooltip
		    placement="bottomLeft"
		    :title="record.reply_content"
		    color="#13c2c2"
		  >
		    <span class="ellipsis">{{ record.reply_content }}</span>
		  </a-tooltip>
		</template>
				<template slot="operation" slot-scope="text, record">
					<a @click="() => handleLook(record)">回复</a>
					<a-divider type="vertical" />
					<popconfirm-button text="删除" alert-title="确定删除？" @onDelete="() => onDelete(record)" />
				</template>
			</a-table>

		</div>

		<a-modal class="contact-modal-wrapper" width="702px" :mask-closable="false" :visible="visible" title="回复留言"
			:footer="null" @cancel="onCancel">
			<el-form ref="form" :model="form" label-width="80px">
				
				<el-form-item label="状态">
				    <el-radio-group v-model="form.status">
						<el-radio :label="1">待审核</el-radio>
				      <el-radio :label="2">发布</el-radio>
				      <el-radio :label="3">隐藏</el-radio>
				    </el-radio-group>
				  </el-form-item>
				<el-form-item label="姓名">
					<div>{{form.user_realname}}</div>
				</el-form-item>
				<el-form-item label="联系电话">
					<div>{{form.mobile}}</div>
				</el-form-item>
				<el-form-item label="留言内容">
					<div>{{form.content}}</div>
				</el-form-item>
				<el-form-item label="上传照片" v-if="form.picture.length>0">
					<el-image v-for="(img,index) in form.picture" style="width: 100px; height: 100px;margin-right: 10px;border-radius: 5px;" :src="img" :preview-src-list="form.picture">
					</el-image>
				</el-form-item>
				<el-form-item label="留言时间">
					<div>{{form.full_create_time_txt}}</div>
				</el-form-item>
				<el-form-item label="回复内容" required>
					<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea">
					</el-input>
				</el-form-item>
				<el-form-item label="回复时间">
					<div>{{form.full_reply_time_txt }}</div>
				</el-form-item>
			</el-form>
			<form-button
			  :btn-is-loading="btnIsLoading"
			  @onCancel="onCancel"
			  @onSubmit="onSubmit"
			/>
			<slot />
		</a-modal>
	</div>
</template>
<script>
	import {
		columns
	} from './data/index';
	export default {
		data() {
			return {
				isStatus:2,
				currentDate :this.getCurrentDate(),
				btnIsLoading: false,
				form: {
					picture:[],
					status:2
				},
				visible: false,
				value: '0',
				columns,
				data: [],
				pageSize: 10,
				current: 1,
				total: 0,
				loading: true,
				keyWord: '',
				status:"0",
				textarea:''
			};
		},
		mounted() {
			// 获取表格数据
			this.getTableData({
				page: String(this.current),
				pageSize: String(this.pageSize),
				status: this.status,
			});
		},
		methods: {
			getCurrentDate() {
			      const now = new Date();
			      const year = now.getFullYear();
			      const month = now.getMonth() + 1; // 月份是从0开始的，所以需要加1
			      const day = now.getDate();
			      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
			    },
			async onDelete(record) {
				console.log("删除", record);
				let result = await this.$http.post("/message/delete", {
					id: record.id,
				});
				console.log(result);

				if (result.data.status === 1) {
					this.$message.success("操作成功！");
					this.getTableData({
						page: String(this.current),
						pageSize: String(this.pageSize),
						status: this.status,
					});
					// this.getTableData({page: pagination.current, pageSize: this.pageSize, type: this.typeId? this.typeId:undefined, keyword: this.keyword});
				}
			},
			// 获取表格数据
			async getTableData(params) {
				this.loading = true;
				let result = await this.$http.post('/message/list', params);
				if (result.data.status === 1) {
					this.loading = false;
					this.total = result.data.data.count;
					this.current = Number(params.page);
					let data = result.data.data.data_list;
					let temp = [];
					data.forEach((item) => {
						let obj = {
							id: item.id,
							user_realname: item.user ? (item.user.user_realname ? item.user.user_realname : '学员'):'学员',
							mobile: item.user ? item.user.mobile:'',
							message_type: item.message_type,
							content: item.content,
							create_time_txt: item.create_time_txt,
							reply_content: item.reply_content,
							reply_time_txt:item.reply_time_txt,
							full_reply_time_txt:item.full_reply_time_txt,
							full_create_time_txt:item.full_create_time_txt,
							picture:item.picture,
							status:item.status
						};
						temp.push(obj);
					});
					this.data = temp;
				}
			},
			onChange(value) {
			  this.current = 1;
			  this.status = value;
			  this.getTableData({
			  	page: String(this.current),
			  	pageSize: String(this.pageSize),
			  	status: this.status,
			  });
			},
			// 查看
			handleLook(record) {
				this.form=record
				this.visible = true
			},
			async onSubmit() {
				this.btnIsLoading = true;
			    let result = await this.$http.post("/message/replay", {
			        status:this.form.status,
			        id:this.form.id,
					reply_content:this.textarea
			      });
			      this.btnIsLoading = false;
			      if (result.data.status === 1) {
			        this.$message.success("操作成功！");
			        this.getTableData({
			          page: String(this.current),
			          pageSize: String(this.pageSize),
			          status: this.status,
			        });
			        this.visible = false;
			      }
			    
			 
			},
			// 取消编辑或新增
			onCancel() {
				this.visible = false
			},
			// 分页
			changePage(pagination) {
				this.current = pagination.current;
				this.getTableData({
					keyword: this.keyWord,
					page: pagination.current,
					pageSize: pagination.pageSize,
				});
			},
		},
	};
</script>
<style lang="scss">
	.client-container {
		.ant-input-search {
			.ant-input {
				border-radius: 20px;
			}
		}
	}
</style>